import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CmsService} from '@spartacus/core';
import {CmsComponentData} from '@spartacus/storefront';
import {combineLatest, Observable} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';

import {AimoCMSSimpleBannerComponent, AimoCMSSimpleBannerContainerComponent} from '../../../model/cms.model';

@Component({
    selector: 'aimo-simple-banner-container',
    templateUrl: './aimo-simple-banner-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoSimpleBannerContainerComponent {
    componentData$: Observable<AimoCMSSimpleBannerContainerComponent>;

    banners$: Observable<AimoCMSSimpleBannerComponent[]>;

    constructor(
        protected component: CmsComponentData<AimoCMSSimpleBannerContainerComponent>,
        protected cmsService: CmsService,
    ) {
        this.componentData$ = this.component.data$.pipe(filter(Boolean));

        this.banners$ = this.componentData$.pipe(
            filter((data) => data != null),
            switchMap((data) =>
                combineLatest(
                    data?.banners
                        ?.split(' ')
                        .map((component) => this.cmsService.getComponentData<AimoCMSSimpleBannerComponent>(component)),
                ),
            ),
        );
    }
}
